import React, { useState, useEffect } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
//superadmin
import Login from './superadmin/pages/Login';
import Sidebar from './superadmin/Layouts/Sidebar';
import Dashboard from './superadmin/pages/Dashboard';
import Admins from './superadmin/pages/Admins';
import Schoollist from './superadmin/pages/School_list';
// import Anganwadi from './superadmin/pages/Anganwadi';
import Forgotpassword from './superadmin/pages/Forgotpassword';
import Drivers from "./superadmin/pages/Drivers";
//admin
import Adminlogin from './admin/pages/Login';
import Adminsidebar from './admin/layouts/Sidebar';
import Admindashboard from './admin/pages/Dasboard';
import Adminschoollist from './admin/pages/School_list';
import AdminForgotpassword from './admin/pages/Forgotpassword';
import AdminInventory from './admin/pages/Inventory';
import AdminTransaction from './admin/pages/Transaction';
import AdminProducts from './admin/pages/Products';
import AdminStudent from './admin/pages/Student';
import Changepassword from "./admin/pages/ResetPassword";
import SuperadminChangePassword from './superadmin/pages/SuperadminResetPassword'
import AdminDrivers from "./admin/pages/Drivers";
import PdfTemplate from "./admin/components/pdfTemplate";
import WastepickerAttendance from "./admin/pages/WastepickerAttendance";
import Class from "./admin/pages/Class";
import Students from "./admin/pages/Students";
import Campaign from "./admin/pages/Campaign";
import Messages from "./admin/pages/Messages";
import Teachers from "./admin/pages/Teachers";

function AdminRoutes() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/admin") {
      navigate("/admin/dashboard");
    }
  }, [location, navigate]);
  return (
    <>
      <Routes>
        <Route path='/' element={<Adminsidebar />} >
          <Route path='/dashboard' element={<Admindashboard />} />
          <Route path='/classes' element={<Class />} />
          <Route path='/Students' element={<Students />} />
          <Route path='/Campaign' element={<Campaign />} />
          <Route path='/Teachers' element={<Teachers />} />
          <Route path='/Messages' element={<Messages />} />
        </Route>
      </Routes>
    </>
  )
}

function SuperadminRoutes() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/superadmin") {
      navigate("/superadmin/dashboard");
    }
  }, [location, navigate]);
  return (
    <>
      <Routes>
        <Route path='/' element={<Sidebar />} >
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/admins' element={<Admins />} />
        </Route>
      </Routes>
    </>
  )
}


function App() {
  const [triggerRefresh, setTriggerRefresh] = useState();
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");

  const authenticated = !!token;

  if (!authenticated) {
    return (
      <Routes>
        <Route path='/superadmin' element={<Login setTriggerRefresh={setTriggerRefresh} />} />
        <Route path='/admin' element={<Adminlogin setTriggerRefresh={setTriggerRefresh} />} />
        <Route path="*" element={<Navigate to="/superadmin" />} />
      </Routes>
    );
  }

  if (role === "schoolAdmin") {
    return (
      <Routes>
          <Route path='/' element={<Navigate to={"superadmin/dashboard"} />} />
          <Route path="/superadmin/*" element={<SuperadminRoutes />} />
        </Routes>
    );
  }

  if (role === "admin") {
    return (
      <Routes>
          <Route path='/' element={<Navigate to={"admin/dashboard"} />} />
          <Route path="/admin/*" element={<AdminRoutes />} />
        </Routes>
    );
  }

  return <Navigate to="/superadmin" />;
}

export default App;

